import type {
    BackstageIdentityApi,
    OAuthApi,
    OpenIdConnectApi,
    ProfileInfoApi,
    SessionApi,
} from "@backstage/core-plugin-api";
import { createApiRef } from "@backstage/core-plugin-api";

/**
 * API reference for JHID (Jack Henry ID) OAuth authentication.
 *
 * Provides OAuth 2.0 / OpenID Connect authentication with JHID, combining:
 * - OAuth authentication flow (OAuthApi)
 * - OpenID Connect identity tokens (OpenIdConnectApi)
 * - User profile information (ProfileInfoApi)
 * - Backstage identity integration (BackstageIdentityApi)
 * - Session management (SessionApi)
 *
 * Use this to authenticate users and obtain access tokens for JHID-protected APIs.
 *
 * @public
 */
export const jhidAuthApiRef = createApiRef<
    OAuthApi &
        OpenIdConnectApi &
        ProfileInfoApi &
        BackstageIdentityApi &
        SessionApi
>({
    id: "core.auth.jhid",
});
